import styled, { css } from 'styled-components';
import { Card, Grid, mediaMixin } from '@zillow/constellation';

export const StyledNoInquiriesCard = styled(Card)`
  height: 316px;
`;

export const StyledColHiddenOnXs = styled(Grid)`
  display: none;

  ${mediaMixin(
    'xl',
    css`
      display: block;
    `,
  )}
`;

export const StyledHiddenOnLTLGGrid = styled(Grid)`
  display: none;

  ${mediaMixin(
    'lg',
    css`
      display: block;
    `,
  )}
`;
